<div class="termos-overlay">
  <div class="termos-backdrop"></div>

  <div class="termos-dialog">
    <div class="termos-header">
      <div class="termos-logo-area">
        <i class="iconoir-lock termos-icon"></i>
        <div>
          <h4 class="termos-title mb-0">Termo de Confidencialidade</h4>
          <p class="termos-subtitle mb-0">Uso das informações da avaliação de risco de extinção</p>
        </div>
        @if (modoConsulta) {
          <button type="button" class="btn-close ms-auto" aria-label="Fechar termos" (click)="onFecharConsulta()"></button>
        }
      </div>
    </div>

    <div class="termos-body">
      <div class="termos-scroll">
        <div class="alert alert-warning mb-3" role="note">
          <strong>Texto provisório.</strong> Este termo ainda será validado pela coordenação do projeto e pela
          assessoria jurídica antes de valer como versão oficial.
        </div>

        <section class="termos-section">
          <h6>1. Objeto</h6>
          <p>
            Este termo estabelece as regras para o uso das informações acessadas na plataforma Lista de Espécies
            Ameaçadas da Flora e Fauna do Estado de Minas Gerais durante o processo de avaliação do risco de
            extinção das espécies.
          </p>
        </section>

        <section class="termos-section">
          <h6>2. Informações confidenciais</h6>
          <p>São consideradas confidenciais, entre outras:</p>
          <ul class="mb-0 ps-3">
            <li>avaliações em andamento, categorias e critérios propostos antes da publicação oficial da lista;</li>
            <li>coordenadas precisas de ocorrência de espécies ameaçadas ou sensíveis;</li>
            <li>dados, imagens e documentos enviados por outros colaboradores;</li>
            <li>pareceres, revisões e discussões técnicas registrados na plataforma.</li>
          </ul>
        </section>

        <section class="termos-section">
          <h6>3. Compromissos do usuário</h6>
          <ul class="mb-0 ps-3">
            <li>Usar as informações apenas para as atividades de avaliação das espécies.</li>
            <li>Não divulgar, copiar ou compartilhar as informações com terceiros sem autorização da coordenação.</li>
            <li>Não publicar resultados das avaliações antes da oficialização da lista.</li>
            <li>Manter em sigilo seu usuário e senha e não permitir o acesso de outras pessoas com sua conta.</li>
            <li>Comunicar à coordenação qualquer acesso indevido ou vazamento de que tenha conhecimento.</li>
          </ul>
        </section>

        <section class="termos-section">
          <h6>4. Exceções</h6>
          <p>O sigilo não se aplica a informações que:</p>
          <ul class="mb-0 ps-3">
            <li>já sejam públicas por outros meios;</li>
            <li>tenham divulgação autorizada por escrito pela coordenação do projeto;</li>
            <li>precisem ser fornecidas por determinação legal ou judicial.</li>
          </ul>
        </section>

        <section class="termos-section">
          <h6>5. Vigência</h6>
          <p>
            O compromisso de sigilo vale durante todo o período de acesso à plataforma e continua após o seu
            término, enquanto as informações não forem tornadas públicas pela coordenação do projeto.
          </p>
        </section>

        <section class="termos-section">
          <h6>6. Descumprimento</h6>
          <p>
            O descumprimento deste termo pode levar à suspensão do acesso à plataforma, sem prejuízo das medidas
            legais cabíveis.
          </p>
        </section>

        @if (modoConsulta) {
          <section class="termos-section" aria-live="polite">
            <h6>Status do aceite</h6>
            @if (aceiteRegistrado) {
              <p>Termos aceitos@if (dataAceite) { em {{ dataAceite | date: 'dd/MM/yyyy HH:mm' }} }.</p>
            } @else {
              <p>Termos não aceitos.</p>
            }
          </section>
        }
      </div>
    </div>

    @if (!modoConsulta) {
    <div class="termos-footer">
      <div class="termos-check-area">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="aceitouTermoConfidencialidadeCheck"
            [(ngModel)]="aceitouTermos"
          />
          <label class="form-check-label" for="aceitouTermoConfidencialidadeCheck">
            Li e concordo com o termo de confidencialidade acima
          </label>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-success termos-btn"
        [disabled]="!aceitouTermos || confirmando"
        (click)="onConfirmar()"
      >
        @if (confirmando) {
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Confirmando...
        } @else {
          <i class="ri-checkbox-circle-line me-1"></i>
          Confirmar e Continuar
        }
      </button>
    </div>
    }
  </div>
</div>
